import { Box, Button } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ReactSortable } from 'react-sortablejs'
import { iWebFieldDropZoneProps, iWebFormField } from './schema';
import { StyledBlockWrapper } from './TrialWebForm';
import SelectWebformField from './SelectWebformField';
import { FieldsContext } from './WebFormWorkspace';
const sortableOptions = {
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.65,
    ghostClass: "ghost",
    group: "shared",
    forceFallback: true
  };
  
const WebFieldDropZone = ({type}:any) => {
    const {blocks,setBlocks,setEditFieldIndex,setEditFieldVal} = useContext(FieldsContext)
    
    const editItem = (id:number,val:iWebFormField) =>{
        setEditFieldIndex(id)
        setEditFieldVal(val)
    }
    const deleteItem = (ind:number) =>{
        setBlocks([...blocks.filter((x:any,index:number)=> index !== ind)])
    }

    const updateBlocksWithLimit = (newBlocks: iWebFormField[]) => {
        if (type === 'TicketAdditionalField' && newBlocks.length > 5) {
            alert(`Max limit of 5 blocks reached. Cannot add more.`)
            // Prevent state update if adding blocks beyond max, or slice array to max length
            // setBlocks(newBlocks.slice(0, MAX_BLOCKS));
        } else {
//             console.log('WebFieldDropZone', blocks?.length,"newBlocks.length",newBlocks.length) 
            setBlocks(newBlocks);
        }
    };

    useEffect(()=>{
//         console.log('WebFieldDropZone', blocks?.length) 
    },[blocks?.length])
    return (
        <>
            <Box className="white-bg webform-holder">
                <div className="webForm-dropable-holder">
                    <ReactSortable  list={blocks} setList={updateBlocksWithLimit} {...sortableOptions}>
                        {blocks.map((block: any, blockIndex: number) => {
                            return (
                                <div key={blockIndex} className="dnd-item">
                                    <StyledBlockWrapper className="block">
                                        <SelectWebformField block={block} />
                                    </StyledBlockWrapper>
                                    <div className="dnd-actions drag-buttons">
                                        <Button onClick={() => { editItem(blockIndex,block) }}>
                                            Edit
                                        </Button>
                                        <Button onClick={() => { deleteItem(blockIndex) }}>
                                            Delete
                                        </Button>
                                    </div>
                                </div>
                            )
                        })}
                    </ReactSortable>
                </div>
            </Box>
        </>
    )
}

export default WebFieldDropZone